// extracted by mini-css-extract-plugin
export default {"loader":"Preloader_loader__thV2j"};